import { render, staticRenderFns } from "./PaymentConfig.vue?vue&type=template&id=511fbf8e&scoped=true&"
import script from "./PaymentConfig.vue?vue&type=script&lang=js&"
export * from "./PaymentConfig.vue?vue&type=script&lang=js&"
import style0 from "./PaymentConfig.vue?vue&type=style&index=0&id=511fbf8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511fbf8e",
  null
  
)

export default component.exports